function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "url(#SVGID_1_)",
  d: "M20.7,13.6l5.9,4.1l7.9-4.1l5.7,2.4l8.1-5.5l8.5,5.3 l6.8-4.8l8.6,4.8l6.7-6.4l6.4,4.8L89,9.4l7.6,5.7l5.3-2.2l6.4,9.9c0,0-2.7,20-3.3,20.1c-0.7,0.1-76.1-1.1-76.1-1.1L15.3,31.6 l0.5-12.4L20.7,13.6z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "url(#SVGID_00000046337008066857757230000015743811738533855677_)",
  d: " M20.7,18.1l5.9,4.1l7.9-4.1l5.7,2.4l8.1-5.5l8.5,5.3l6.8-4.8l8.6,4.8l6.7-6.4l6.4,4.8l3.7-4.8l7.6,5.7l5.3-2.2l6.4,9.9 c0,0-2.7,20-3.3,20.1c-0.7,0.1-76.1-1.1-76.1-1.1L15.3,36.1l0.5-12.4L20.7,18.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "url(#SVGID_00000016789204656073039020000002565190808960502201_)",
  d: " M20.7,13.6C10.5,22.4-4.6,40.8,3.3,69c8,28.8,28.3,43,66.9,42c38.7-1.1,53.3-37.6,49.1-62.4c-3-17.9-10.5-29.3-17.4-35.6l1.3,5.1 l-10.6-2.8l-1.5,8.3l-11-4l-7,8.5l-11.5-7.9l-14.2,8.9l-4-10.4l-12.1,4l-2.5-7.9l-11,4L20.7,13.6z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#A83512",
  d: "M32.6,103.7c0,0-24.5-16.3-25.7-41C5.7,37.9,18.1,18.9,18.1,18.9 S5.9,33.8,5.3,58C4.8,82.1,22,96.4,32.6,103.7z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#A83512",
  d: "M89.8,103.7c0,0,24.5-16.3,25.7-41s-11.2-43.8-11.2-43.8 s12.2,14.9,12.8,39.1C117.7,82.1,100.4,96.4,89.8,103.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#A83512",
  d: "M31.4,22.7c-1.3,2.8-2.5,6.1-3.5,9.9 c-4.8,17.7-2.8,59.5,13.6,73.6c0,0-14.2-12.9-14.7-53.9c0,0,0.7-18.9,6-29.8l0.1-0.3L31.4,22.7z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#A83512",
  d: "M47.1,28.2c-0.6,1.7-1.2,3.6-1.7,5.5 c-4.9,18.4-7.3,56.9,12.1,74.6c0,0-12.8-11.2-13.3-54c0,0,0.5-14.3,3.9-25.6l-0.7,0.5L47.1,28.2z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#A83512",
  d: "M90.2,23.2c3.3,8.4,5.8,20.8,4.1,37.7 c-3.5,34.4-16.5,45.9-16.5,45.9s13.9-7.5,17.9-41c1.6-20.6-1-34.1-4.4-42.8l-0.1,0.6L90.2,23.2z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#A83512",
  d: "M72.1,27.3c1,8,1.7,19,0.8,33.6c-2,34.4-5.6,48.2-5.6,48.2 s4.9-10.6,7.2-44.1c0.8-17,0.1-28.9-1.1-37.2l-0.2,0.3L72.1,27.3z"
}));

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F37521",
  points: "27.2,17.4 19.3,19.7 26.9,18.8 28.5,21.2  "
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F16722",
  points: "34.8,23.1 42.3,20.3 44.3,25 41.5,22  "
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F16722",
  points: "52.6,28.2 62,22.6 66.7,25.3 62.2,23.9  "
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F37521",
  d: "M15.8,20.1c0,0-7.4,8.3-9.4,13.7s-2.8,9.5-2.8,9.5 S8,30.7,15.8,20.1z"
});

var Svg1 = function Svg1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    enableBackground: "new 0 0 120 120",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 61.8,
    cy: 81.0442,
    r: 39.7368,
    gradientTransform: "matrix(1 0 0 -1 0 122)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDD2A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#FFCC02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCC02"
    }
  })), _ref2, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000046337008066857757230000015743811738533855677_",
    cx: 61.8,
    cy: 76.5708,
    r: 27.8407,
    gradientTransform: "matrix(1 0 0 -1 0 122)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFBD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#FFF100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF100"
    }
  })), _ref3, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000016789204656073039020000002565190808960502201_",
    cx: 60.5459,
    cy: 59.0162,
    r: 70.6556,
    gradientTransform: "matrix(1 0 0 -1 0 122)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6411F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#C6431F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#EF5323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF5323"
    }
  })), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1.cf2f3a2d.svg";
export { ForwardRef as ReactComponent };